import React, { useState, useCallback, useMemo } from 'react'
import { DateRange } from 'react-date-range'
import { Button, Col, Modal, ModalBody, ModalFooter, Row, Spinner } from 'reactstrap'
import moment from 'moment'

function SelectDateSyncData({ isOpen, onClose, onChangeRangeDate }) {
  const [rangeDate, setRangeDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ])
  const [focusedRange, setFocusedRange] = useState([0, 0])
  const [submitting, setSubmitting] = useState(false)

  const isSelectingEndDate = focusedRange[1] === 1
  const minDate = isSelectingEndDate ? rangeDate[0].startDate : undefined
  const maxDate = new Date()

  const handleSelectDate = useCallback((ranges) => {
    const { startDate } = ranges.selection
    let { endDate } = ranges.selection

    if (startDate && endDate) {
      const startMom = moment(startDate)
      const endMom = moment(endDate)

      if (endMom.isBefore(startMom)) {
        endDate = startDate
      }
    }

    setRangeDate([{ startDate, endDate, key: 'selection' }])
  }, [])

  const isInvalidRange = useMemo(() => {
    const { startDate, endDate } = rangeDate[0]
    if (startDate && endDate) {
      const startMom = moment(startDate)
      const endMom = moment(endDate)
      return endMom.diff(startMom, 'months', true) > 3
    }
    return false
  }, [rangeDate])

  const handleSubmitDate = useCallback(async () => {
    setSubmitting(true)
    try {
      await Promise.resolve(onChangeRangeDate(rangeDate))
    } finally {
      setSubmitting(false)
    }
  }, [onChangeRangeDate, rangeDate])

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalBody>
        <DateRange
          editableDateInputs={true}
          moveRangeOnFirstSelection={false}
          onChange={handleSelectDate}
          ranges={rangeDate}
          className='w-100'
          focusedRange={focusedRange}
          onRangeFocusChange={setFocusedRange}
          minDate={minDate}
          maxDate={maxDate}
        />
        {isInvalidRange && (
          <div className='text-danger text-center' style={{ fontSize: '13px' }}>Date range must be within 3 months</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col>
            <Button color='primary' role='button' onClick={handleSubmitDate} disabled={submitting || isInvalidRange}>
              {submitting ? (
                <>
                  <Spinner size='sm' className='me-2' /> Loading...
                </>
              ) : (
                'Ok'
              )}
            </Button>
          </Col>
          <Col>
            <button
              className='bg-transparent text-black btn-cancel-calendar'
              type='button'
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default React.memo(SelectDateSyncData)
